import moment from 'moment';

//Format Outcome Example: 07.04.2025
export const convertIsoDateToDDMMYYYY = (dateString: string) => {
    const date = new Date(dateString);

    if (isNaN(date)) {
        throw new Error('Invalid ISO string');
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
};

//Format Outcome Example: 07.04.25
export const convertIsoDateToDDMMYY = (dateString: string) => {
    const date = new Date(dateString);

    if (isNaN(date)) {
        throw new Error('Invalid ISO string');
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear().toString().slice(-2);

    return `${day}.${month}.${year}`;
};

//Format Outcome Example: 07 Apr 2025
export const convertIsoDateToDDMMNYYYY = (dateString: string) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        throw new Error('Invalid ISO string');
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
};

//Format Outcome Example: January 15, 2025
export const convertIsoDateToMMMMDDYYYY = (dateString: string) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        throw new Error('Invalid ISO string');
    }

    const month = date.toLocaleString('en-US', { month: 'long' });
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
};

//Format Outcome Example: 2025-04-07
export const formatToYYYYMMDD = (dateString: string) => {
    const date = moment(dateString);

    if (!date.isValid()) {
        throw new Error('Invalid date string');
    }

    return date.format('YYYY-MM-DD');
};

//Format Outcome Example: Jul 1, 2026 14:30
export const convertIsoDateToMMMDYYYYHHmm = (dateString: string) => {
    const date = moment(dateString);

    if (!date.isValid()) {
        throw new Error('Invalid date string');
    }

    return date.format('MMM D, YYYY HH:mm');
};

//Format Outcome Example: Sun, Mar 29, 2026
export const convertDateToDDDMMMDDYYYY = (
    dateString: string,
    locale: string = 'en-US'
) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        throw new Error('Invalid date string');
    }

    return date.toLocaleDateString(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};

//Format Outcome Examples: "2:30 PM", "Yesterday 3:45 PM", "Nov 21, 10:15 AM"
export const formatMessageTime = (dateString: string): string => {
    const messageDate = moment(dateString);
    const now = moment();
    const yesterday = moment().subtract(1, 'day');

    if (messageDate.isSame(now, 'day')) {
        return messageDate.format('h:mm A');
    } else if (messageDate.isSame(yesterday, 'day')) {
        return `Yesterday ${messageDate.format('h:mm A')}`;
    } else {
        return messageDate.format('MMM D, h:mm A');
    }
};
